import type { ListBuilderList } from '../../../types';
import { createStandardClientColumns } from '../columns';
import {
	createClientKanbanConfig,
	DEFAULT_LIST_REQUIRED_FIELDS,
} from '../shared';

/**
 * Active Customers list configuration
 * Customers in "Active" lifecycle stage
 */
export const activeCustomersList: ListBuilderList = {
	id: 'active-customers-list',
	cacheTTL: 600000,
	name: 'Active Customers',
	type: 'default',
	active: true,
	bulkActionTemplate: 'clients',
	sortOrder: 3,
	filterRules: {
		lifecycleStageName: {
			defaultValue: ['Active'],
			locked: true,
			hidden: true,
		},
		salespeople: {
			defaultValue: [],
			additionalValues: [
				{
					values: [{ id: 'ME', label: 'Me' }],
					applyIf: {
						type: 'group',
						joiner: 'AND',
						negated: false,
						children: [
							{ type: 'rule', action: 'clients:view:self', negated: false },
						],
					},
				},
				{
					values: [{ id: 'ME_ALTERNATE', label: 'Me (Alternate)' }],
					applyIf: {
						type: 'group',
						joiner: 'AND',
						negated: false,
						children: [
							{ type: 'rule', action: 'clients:view:self', negated: false },
						],
					},
					applyAsDefault: false,
				},
				{
					values: [{ id: 'null', label: 'Unassigned' }],
					applyIf: {
						type: 'group',
						joiner: 'AND',
						negated: false,
						children: [
							{
								type: 'rule',
								action: 'clients:view:unassigned',
								negated: false,
							},
						],
					},
					applyAsDefault: false,
				},
			],
			applyDefaultIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [{ type: 'rule', action: 'clients:list:any', negated: true }],
			},
			boundedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [{ type: 'rule', action: 'clients:list:any', negated: true }],
			},
		},
		leadOrCustomer: {
			defaultValue: {
				id: 'Customer',
				label: 'Customer',
			},
			locked: true,
			hidden: true,
		},
	},
	columns: createStandardClientColumns(),
	description: 'Active customers with ongoing business',
	defaultSortId: 'column-client-name-asc',
	requiredFields: DEFAULT_LIST_REQUIRED_FIELDS,
	kanbanConfig: createClientKanbanConfig(),
};
